export default __webpack_public_path__ + "static/media/SUPER_GUC.cf5be3c4.png";